export const RIGHT_LIST = ['Aucun', 'Utilisateur', 'Admin'];